export const featuredTestimonials = [
  {
    initials: 'MR',
    text: 'It saved me so much time. I walked into Monday fully prepared, no scrambling. Highly recommend it.',
    author: 'Mark R.',
    role: 'Functional Coach · United States',
    bg: 'bg-blue-600',
  },
  {
    initials: 'CP',
    text: 'I had my doubts before buying, but it surprised me. With the three versions I handle mixed-level groups with zero stress.',
    author: 'Caroline P.',
    role: 'Instructor · Canada',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'DG',
    text: 'I put a class together in 10 minutes and it shows. For what it costs, I recommend it without hesitation.',
    author: 'David G.',
    role: 'Boxing Coach · United Kingdom',
    bg: 'bg-blue-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'LM',
    name: 'Lucy M.',
    location: 'Australia',
    text: 'I used to show up to Monday exhausted. Now I open the volume and in 5 minutes my class is ready.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'JP',
    name: 'John P.',
    location: 'United States',
    text: "I bought it a little skeptical and it surprised me: it's far more complete than I expected.",
    bg: 'bg-cyan-600',
  },
  {
    initials: 'VR',
    name: 'Victoria R.',
    location: 'Ireland',
    text: 'The warm-ups and class closers saved me. You can tell every class has structure from start to finish.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'FA',
    name: 'Fraser A.',
    location: 'New Zealand',
    text: 'It saved me so much time. I no longer lose my Sundays building sessions. Highly recommend it.',
    bg: 'bg-cyan-600',
  },
]
